let gaInitPromise = null;

function injectGtagScript(measurementId) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[data-ga4="${measurementId}"]`)) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
      measurementId,
    )}`;
    script.dataset.ga4 = measurementId;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load gtag.js"));
    document.head.appendChild(script);
  });
}

export function initAnalytics() {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!measurementId) return null;

  if (!gaInitPromise) {
    gaInitPromise = injectGtagScript(measurementId)
      .catch(() => undefined)
      .then(() => {
        window.dataLayer = window.dataLayer || [];
        window.gtag =
          window.gtag ||
          function gtag() {
            window.dataLayer.push(arguments);
          };

        window.gtag("js", new Date());
        window.gtag("config", measurementId, {
          send_page_view: false,
          anonymize_ip: true,
        });
      });
  }

  return gaInitPromise;
}

export function trackPageView(path) {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!measurementId) return;
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;

  window.gtag("event", "page_view", {
    page_location: window.location.href,
    page_path: path,
    page_title: document.title,
    send_to: measurementId,
  });
}
